<template>
  <div class="card">
    <p class="title">{{title}}</p>
    <ul>
      <li v-for="(item, index) of list" class="item" @click="selectItem(item.index)">
        <a href="javascript: void(0)" class="item-link" v-html="item.question"></a>
      </li>
    </ul>
    <div class="default" v-if="list.length === 0">
      <slot></slot>
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    selectItem: {
      type: Function
    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    margin: 0 auto;
    width: 830px;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
    font-size: 14px;
  }

  .title {
    margin: 0;
    padding: 0 30px;
    line-height: 50px;
    font-size: 16px;
    font-weight: bold;
    color: #000;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
  }

  .item {
    padding: 0 30px;
    background: rgba(69, 126, 236, 0.1);
    cursor: pointer;

    &:hover {
      background: rgba(69, 126, 236, 0.2);
    }
  }

  .item-link {
    line-height: 40px;
    font-size: 14px;
    color: #505060;
  }

  .default {
    min-height: 250px;
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/page/help/components/card.vue